import { createFileRoute } from "@tanstack/react-router";
import PartnerPage from "@/pages/PartnerPage";
import { buildRouteHead } from "@/lib/route-head";
import { breadcrumbSchema, partnerListSchema } from "@/lib/schema";
import { partners } from "@/data/partners";

export const Route = createFileRoute("/netzwerk/")({
  head: () =>
    buildRouteHead({
      title: "Unser Netzwerk | Enno & Jens – Agentur aus dem Harz",
      description:
        "Unser Netzwerk aus Experten für Fotografie, Rechtssicherheit und mehr – gemeinsam realisieren wir Ihr digitales Projekt.",
      path: "/netzwerk",
      scripts: [
        partnerListSchema(
          partners.map((p) => ({
            name: p.name,
            description: p.description,
            website: p.website,
            location: p.location,
          })),
        ),
        breadcrumbSchema([
          { name: "Startseite", path: "/" },
          { name: "Netzwerk", path: "/netzwerk" },
        ]),
      ],
    }),
  component: PartnerPage,
});
